module.exports = __webpack_public_path__ + "OptionHelp.png";